<p-toast position="top-right"></p-toast>

<div class="card reports-page text-gray-800 dark:text-gray-100">
  <div class="reports-header mb-8">
    <div>
      <div class="flex items-center gap-3 mb-2">
        <span class="reports-header-icon"><i class="pi pi-chart-bar"></i></span>
        <div>
          <p class="text-sm uppercase tracking-[0.18em] text-blue-600 dark:text-blue-400 font-semibold mb-1">Reports</p>
          <h1 class="text-3xl md:text-4xl font-light text-gray-800 dark:text-gray-100">Reporte de agentes</h1>
        </div>
      </div>
      <p class="text-base text-gray-600 dark:text-gray-300 font-normal max-w-3xl">
        Explora conversaciones iniciadas y mensajes por cuenta, periodo y canal.
      </p>
    </div>
  </div>

  <div class="reports-card reports-filter-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.2fr)_minmax(0,1.2fr)_auto] gap-4 items-end">
      <div>
        <label for="fromDate" class="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Fecha desde</label>
        <p-datepicker
          inputId="fromDate"
          [(ngModel)]="fromDate"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          [disabled]="loading"
          placeholder="Seleccionar fecha"
          styleClass="w-full"
          appendTo="body">
        </p-datepicker>
      </div>

      <div>
        <label for="toDate" class="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Fecha hasta</label>
        <p-datepicker
          inputId="toDate"
          [(ngModel)]="toDate"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          [disabled]="loading"
          placeholder="Seleccionar fecha"
          styleClass="w-full"
          appendTo="body">
        </p-datepicker>
      </div>

      <div>
        <label for="accountId" class="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Cuenta</label>
        <p-select
          inputId="accountId"
          [options]="accountOptions"
          [(ngModel)]="selectedAccountId"
          optionLabel="label"
          optionValue="value"
          [disabled]="loading || accountsLoading"
          class="w-full">
        </p-select>
      </div>

      <div>
        <label for="channels" class="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Canales</label>
        <p-multiselect
          inputId="channels"
          [options]="channelOptions"
          [(ngModel)]="selectedChannels"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos los canales"
          [filter]="true"
          filterBy="label"
          [maxSelectedLabels]="1"
          selectedItemsLabel="{0} canales seleccionados"
          [showToggleAll]="false"
          [disabled]="loading || accountsLoading"
          appendTo="body"
          styleClass="w-full">
          <ng-template pTemplate="item" let-option>
            <div class="flex items-center gap-2">
              <i [class]="option.icon"></i>
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
      </div>

      <div class="flex flex-col sm:flex-row gap-2 w-full xl:col-span-4 2xl:col-span-1 2xl:w-auto">
        <button
          pButton
          type="button"
          label="Consultar"
          icon="pi pi-search"
          class="p-button-success w-full sm:w-auto"
          [loading]="loading"
          [disabled]="loading || accountsLoading"
          (click)="consultReports()">
        </button>

        <button
          pButton
          type="button"
          label="Exportar Excel"
          icon="pi pi-download"
          class="p-button-outlined p-button-secondary w-full sm:w-auto"
          [loading]="exporting"
          [disabled]="!canExport"
          (click)="exportReportsToExcel()">
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 rounded-lg px-4 py-3 mb-6 flex items-center gap-2">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <div *ngIf="!hasSearched && !loading" class="text-center py-14 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700">
    <i class="pi pi-filter text-4xl text-gray-300 dark:text-gray-600 mb-4 block"></i>
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">Selecciona filtros y consulta reportes</h3>
    <p class="text-gray-600 dark:text-gray-300">Puedes consultar todas las cuentas o limitar la búsqueda por fecha y cuenta.</p>
  </div>

  <div *ngIf="loading" class="flex flex-col items-center justify-center py-14 gap-4 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700">
    <p-progressSpinner styleClass="w-12 h-12" strokeWidth="4" animationDuration="1s"></p-progressSpinner>
    <p class="text-gray-600 dark:text-gray-300">Cargando reportes...</p>
  </div>

  <div *ngIf="hasSearched && !loading && !hasResults && !errorMessage" class="text-center py-14 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700">
    <i class="pi pi-inbox text-4xl text-gray-300 dark:text-gray-600 mb-4 block"></i>
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">No se encontraron reportes</h3>
    <p class="text-gray-600 dark:text-gray-300">No se encontraron reportes para los filtros seleccionados.</p>
  </div>

  <div *ngIf="hasResults && !loading" class="flex flex-col gap-6">
    <div *ngIf="consistencyWarnings.length" class="reports-consistency-note" role="status">
      <i class="pi pi-info-circle"></i>
      <span>Se detectaron {{ consistencyWarnings.length }} diferencias menores en la suma de algunas métricas.</span>
    </div>

    <section aria-labelledby="summary-title">
      <div class="flex items-center justify-between gap-4 mb-3">
        <div>
          <h2 id="summary-title" class="reports-section-title">Resumen del periodo</h2>
          <p class="reports-section-subtitle">Métricas calculadas con los resultados de la última consulta.</p>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        <div *ngFor="let kpi of kpis" class="reports-kpi-card bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-4 shadow-sm">
          <div class="flex items-start justify-between gap-3">
            <div class="min-w-0">
              <p class="text-sm text-gray-500 dark:text-gray-400 mb-2 leading-snug">{{ kpi.label }}</p>
              <p class="text-2xl font-semibold text-gray-800 dark:text-gray-100 tabular-nums">
                {{ kpi.value | number:(kpi.numberFormat || '1.0-0') }}
              </p>
            </div>
            <div class="reports-kpi-icon">
              <i [class]="kpi.icon"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="grid grid-cols-1 xl:grid-cols-2 gap-6" aria-label="Distribución de mensajes">
      <div class="reports-card reports-visual-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
        <div class="mb-3">
          <h2 class="reports-section-title">Mensajes recibidos vs. enviados</h2>
          <p class="reports-section-subtitle">Distribución de mensajes según su dirección.</p>
        </div>
        <div class="reports-donut-layout">
          <div class="reports-chart reports-chart-donut">
            <p-chart type="doughnut" [data]="inboundOutboundChartData" [options]="donutChartOptions" ariaLabel="Distribución de mensajes recibidos y enviados"></p-chart>
          </div>
          <div class="reports-direction-list">
            <div class="reports-direction-row">
              <span class="reports-legend-dot reports-legend-blue"></span>
              <div>
                <p class="reports-direction-label">Recibidos</p>
                <p class="reports-direction-value">{{ totals.inbound | number }}</p>
              </div>
              <span class="reports-direction-percent">{{ formatPercentage(totals.inboundPercentage) }}</span>
            </div>
            <div class="reports-direction-row">
              <span class="reports-legend-dot reports-legend-green"></span>
              <div>
                <p class="reports-direction-label">Enviados</p>
                <p class="reports-direction-value">{{ totals.outbound | number }}</p>
              </div>
              <span class="reports-direction-percent">{{ formatPercentage(totals.outboundPercentage) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="reports-card reports-visual-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
        <div class="mb-3">
          <h2 class="reports-section-title">Distribución por canal</h2>
          <p class="reports-section-subtitle">Principales canales por total de mensajes.</p>
        </div>
        <div class="reports-chart reports-chart-channel">
          <p-chart type="bar" [data]="channelChartData" [options]="barChartOptions" ariaLabel="Distribución de mensajes por canal"></p-chart>
        </div>
      </div>
    </section>

    <section class="reports-card reports-visual-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5" aria-labelledby="monthly-title">
      <div class="mb-3">
        <h2 id="monthly-title" class="reports-section-title">Tendencia mensual</h2>
        <p class="reports-section-subtitle">Mensajes totales, recibidos y enviados ordenados por mes.</p>
      </div>
      <div class="reports-chart reports-chart-wide">
        <p-chart type="line" [data]="monthlyMessagesChartData" [options]="chartOptions" ariaLabel="Tendencia mensual de mensajes"></p-chart>
      </div>
    </section>

    <section class="reports-card reports-visual-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5" aria-labelledby="conversations-title">
      <div class="mb-3">
        <h2 id="conversations-title" class="reports-section-title">Conversaciones iniciadas por mes</h2>
        <p class="reports-section-subtitle">Cantidad de conversaciones creadas en cada mes del periodo.</p>
      </div>
      <div class="reports-chart reports-chart-wide reports-chart-conversations">
        <p-chart type="bar" [data]="monthlyConversationsChartData" [options]="chartOptions" ariaLabel="Conversaciones iniciadas por mes"></p-chart>
      </div>
    </section>

    <section class="reports-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden" aria-labelledby="channels-title">
      <div class="p-5 pb-3">
        <h2 id="channels-title" class="reports-section-title">Resumen por canal</h2>
        <p class="reports-section-subtitle">Detalle completo de los canales presentes en los resultados.</p>
      </div>
      <div class="overflow-x-auto">
        <p-table [value]="channelAggregates" [tableStyle]="{ 'min-width': '46rem' }" styleClass="reports-table">
          <ng-template pTemplate="header">
            <tr>
              <th class="bg-gray-50 dark:bg-gray-800">Canal</th>
              <th class="bg-gray-50 dark:bg-gray-800 !text-right">Total mensajes</th>
              <th class="bg-gray-50 dark:bg-gray-800 !text-right">Recibidos</th>
              <th class="bg-gray-50 dark:bg-gray-800 !text-right">Enviados</th>
              <th class="bg-gray-50 dark:bg-gray-800 !text-right">% del total</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-channel>
            <tr>
              <td class="font-medium text-gray-700 dark:text-gray-200">{{ channel.displayName }}</td>
              <td class="!text-right tabular-nums">{{ channel.messageCount | number }}</td>
              <td class="!text-right tabular-nums">{{ channel.inboundMessageCount | number }}</td>
              <td class="!text-right tabular-nums">{{ channel.outboundMessageCount | number }}</td>
              <td class="!text-right tabular-nums">{{ formatPercentage(channel.percentage) }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>

    <section class="reports-card bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden" aria-labelledby="detail-title">
      <div class="p-5 pb-3">
        <h2 id="detail-title" class="reports-section-title">Tabla detallada</h2>
        <p class="reports-section-subtitle">Expande una fila para revisar el detalle dinámico de sus canales.</p>
      </div>

      <div class="overflow-x-auto">
        <p-table
          [value]="reports"
          dataKey="rowKey"
          [expandedRowKeys]="expandedRows"
          [paginator]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}"
          [rowsPerPageOptions]="[10, 25, 50]"
          [scrollable]="true"
          responsiveLayout="scroll"
          [rowHover]="true"
          styleClass="reports-table"
          [tableStyle]="{ 'min-width': '64rem' }">

          <ng-template pTemplate="header">
            <tr>
              <th class="bg-gray-50 dark:bg-gray-800" style="width: 3.5rem"></th>
              <th pSortableColumn="month" class="bg-gray-50 dark:bg-gray-800">Mes <p-sortIcon field="month"></p-sortIcon></th>
              <th pSortableColumn="accountName" class="bg-gray-50 dark:bg-gray-800">Cuenta <p-sortIcon field="accountName"></p-sortIcon></th>
              <th pSortableColumn="conversationCount" class="bg-gray-50 dark:bg-gray-800 !text-right">Conversaciones iniciadas <p-sortIcon field="conversationCount"></p-sortIcon></th>
              <th pSortableColumn="messageCount" class="bg-gray-50 dark:bg-gray-800 !text-right">Mensajes <p-sortIcon field="messageCount"></p-sortIcon></th>
              <th class="bg-gray-50 dark:bg-gray-800 !text-right">Recibidos</th>
              <th class="bg-gray-50 dark:bg-gray-800 !text-right">Enviados</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-report let-expanded="expanded">
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
              <td>
                <button
                  type="button"
                  pButton
                  pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  [pRowToggler]="report"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  [attr.aria-label]="expanded ? 'Ocultar detalle de canales' : 'Mostrar detalle de canales'"></button>
              </td>
              <td class="text-gray-700 dark:text-gray-200">{{ formatMonth(report.month) }}</td>
              <td class="text-gray-700 dark:text-gray-200">{{ report.accountName }}</td>
              <td class="!text-right font-medium tabular-nums">{{ report.conversationCount | number }}</td>
              <td class="!text-right font-medium tabular-nums">{{ report.messageCount | number }}</td>
              <td class="!text-right tabular-nums">{{ report.inboundMessageCount | number }}</td>
              <td class="!text-right tabular-nums">{{ report.outboundMessageCount | number }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-report>
            <tr>
              <td colspan="7" class="reports-expansion-cell">
                <div class="reports-expansion-wrapper">
                  <div class="flex items-center justify-between gap-3 mb-3">
                    <div>
                      <p class="font-semibold text-gray-800 dark:text-gray-100">Detalle por canal</p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatMonth(report.month) }} · {{ report.accountName }}</p>
                    </div>
                  </div>
                  <div *ngIf="report.channelDetails.length; else noChannelDetails" class="overflow-x-auto">
                    <table class="w-full min-w-[38rem] text-sm">
                      <thead>
                        <tr class="text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          <th class="text-left font-medium py-2 pr-4">Canal</th>
                          <th class="text-right font-medium py-2 px-4">Total</th>
                          <th class="text-right font-medium py-2 px-4">Recibidos</th>
                          <th class="text-right font-medium py-2 pl-4">Enviados</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let channel of report.channelDetails" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
                          <td class="py-2 pr-4 text-gray-700 dark:text-gray-200">{{ formatChannelName(channel.channel) }}</td>
                          <td class="py-2 px-4 text-right tabular-nums">{{ channel.messageCount | number }}</td>
                          <td class="py-2 px-4 text-right tabular-nums">{{ channel.inboundMessageCount | number }}</td>
                          <td class="py-2 pl-4 text-right tabular-nums">{{ channel.outboundMessageCount | number }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <ng-template #noChannelDetails>
                    <p class="text-sm text-gray-500 dark:text-gray-400">No hay detalle de canales para esta fila.</p>
                  </ng-template>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center p-8 text-gray-500 dark:text-gray-400">No se encontraron reportes para los filtros seleccionados.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>
  </div>
</div>
